import { helper } from '@ember/component/helper';
import { add } from 'date-fns';
export default helper(function tomorrow() {
  return add(new Date(), { days: 1 });
});
